import * as React from "react";
import { Box, Typography } from "@mui/material";

import RedirectButton from "../../../ui-components/Buttons/RedirectButton";
import { useSelector } from "react-redux";


/**
 * For ACSF3 and ACSF3 Short Course only
 * @returns 
 */
export default function MobileInfo() {
	const client = useSelector((state) => state.client || {});
	return (
		<React.Fragment>
			<Box
				sx={{
					bgcolor: "white",
					height: "100%",
					width: { xs: "100%", sm: "calc(100% - 4px)" },
					p: 3,
					overflow: "auto",
					borderRadius: "18px 18px 0px 0px",
				}}
			>
				<Typography variant="h6" sx={{ mt: 2 }}>
					Before you start your course we want you to complete this
					quiz.
				</Typography>
				<Typography variant="h6" sx={{ mt: 2 }}>
					It will give us a clear picture of your current language,
					literacy and numeracy skills. This will help us to support
					you and offer you advice about your course.
				</Typography>

				<Typography variant="h6" sx={{ mt: 2 }}>
					The quiz can take up to 30 minutes to complete.
				</Typography>
				{client?.details && (
					<Typography variant="h6" sx={{ mt: 1, mb: 5 }}>
						Please contact{" "}
						{client?.details?.displayName ||
							"The Learning Resources Group"}{" "}
						on{" "}
						{client?.details?.preferences?.learnerCorrespondence
							?.phone || "1300 221 729"}
						&nbsp;or email any questions you have to {client?.details?.preferences?.learnerCorrespondence
							?.email || "m.peachey@tlrg.com.au"}
					</Typography>
				)}

				<RedirectButton url="/form" title="CONTINUE" />
			</Box>
		</React.Fragment>
	);
}